import { render } from "./NotificationSnackbar.vue?vue&type=template&id=6056f74a&scoped=true"
import script from "./NotificationSnackbar.vue?vue&type=script&lang=js"
export * from "./NotificationSnackbar.vue?vue&type=script&lang=js"

import "./NotificationSnackbar.vue?vue&type=style&index=0&id=6056f74a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6056f74a"]])

export default __exports__